<mat-dialog-content>
    <h2 class="mat-dialog-title">Cancel {{type}}</h2>

    <div>
        <p><strong>Are you sure?</strong></p>
        <p>Cancelling this {{type.toLowerCase()}} will result in the loss of all information you've entered so far</p>
    </div>

    <div class="button-container">
        <button class="btn btn-secondary" (click)="closeMe()">No, take me back</button>
        <button class="btn btn-primary pull-right" (click)="cancel()">Yes, Cancel {{type}}</button>
    </div>
</mat-dialog-content>